// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cnqok{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;gap:8px;gap:.8rem;padding:1.6rem}", ""]);
// Exports
exports.locals = {
	"actions": "cnqok"
};
module.exports = exports;
